import { createContext } from "react";
import { RedoAdminClient } from ".";

export const RedoAdminClientContext = createContext<
  RedoAdminClient | undefined
>(undefined);
